import React from "react";
import "./DeactivateAccount.css";
const DeactivateAccount = () => {
  const handaleClick = () => {
    alert("Account Deactivated");
  };
  
  return (
    <div className="settings-content">
      <h2>Deactivate Account</h2>
      <p className=" DeactivateAccountP">Warning : This action is irreversible.</p>
      <button className="DeactivateAccountBtn" onClick={handaleClick}>Deactivate Account</button>
    </div>
  );
};

export default DeactivateAccount;
